import React                 from 'react';

import Directory             from 'components/Directory/Directory';

import { HomePageContainer } from 'pages/HomePage/homepage.styles';

const HomePage = () => (
	<HomePageContainer>
		<Directory />
	</HomePageContainer>
);

export default HomePage;
